export enum ContentEventType {
  promo_completed = 'promo_completed',
  promo_dismissed = 'promo_dismissed',
}
